import moment from "moment/moment";
import {TAG} from "../../component/generate-form/GenerateFormConfig";
import {getValueByAdvancedJS} from "../../utils/AppFunction";

export const formatDateToText = (value: string) => {
  if (!value) return '';

  const date = moment(value);

  const hour = date.get('hour');
  const minute = date.get('minute');
  const day = date.get('date').toString().padStart(2, '0');
  const month = (date.get('month') + 1).toString().padStart(2, '0');
  const year = date.get('year');

  return `${hour} giờ ${minute} phút, ngày ${day}/${month}/${year}`;
};

export const formatBirthdateToText = (day: number, month: number, year: number, delimiter = '') => {
  if (!day && !month && !year) return '';

  return [day, month, year]
    .filter((item) => item)
    .map((item) => item.toString().padStart(2, '0'))
    .join(delimiter);
};

export const isDisabledTab = (formJSONTag: string[]) => (formJSONTag ?? []).includes(TAG.DISABLED);

export const convertPayloadSubmit = (dataBenhNhan: any = {}, params?: any, config?: any) => {
  const data = {
    ...dataBenhNhan,
    ...(params || {}),
    visitId: params?.visitId || dataBenhNhan.visitId,
    tabCode: params?.tabCode || dataBenhNhan.tabCode,
  }
  let additionalData = {}

  if (config) {
    additionalData = getValueByAdvancedJS(config, data) || {};
  }

  return {...data, ...additionalData};
}

export const convertRecordData = (initialData: Record<string, any>, defaultData: Record<string, any>) => {
  if (initialData.id) return {...defaultData, ...initialData};

  const data: Record<string, any> = {};
  const keyMap: Record<string, true> = {};

  for (const key in defaultData) keyMap[key] = true;
  for (const key in initialData) keyMap[key] = true;

  for (const key in keyMap) {
    data[key] = initialData[key] ?? defaultData[key] ?? null;
  }
  
  return data;
}
